import { Tooltip } from './components/default-ui/Tooltip'

export { CopilotStep } from './components/CopilotStep'
export { CopilotProvider, useCopilot } from './contexts/CopilotProvider'
export { walkthroughable } from './hocs/walkthroughable'
export type { CopilotOptions as CopilotProps, TooltipProps } from './types'

export const DefaultUI = {
  Tooltip,
}
